import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 品牌新訊/促銷訊息 列表頁
  {
    path: '/news',
    name: 'news-list',
    // component: () => lazyLoadView(import('@views/News/Category')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        next({ name: 'news-category', params: { categoryAlias: 'bulletin' } })
      },
      alias: "news",
      title: '最新消息列表',
    },
  },
  // 代理品牌 品牌新訊/促銷訊息 分類頁
  {
    path: '/news/:categoryAlias',
    name: 'news-category',
    component: () => lazyLoadView(import('@views/News/Category')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { brand, query, month, page = 1 } = routeTo.query
          const params = {
            search: query || undefined,
            brand_alias: brand
              ? [brand]
              : undefined,
            search_date: month || undefined,
            limit: 10,
            page,
          }
          const [{ items, featured, pagination }, brandOptions] = await Promise.all([
            store.dispatch('article/fetchList', {
              contentAlias: routeTo.params.categoryAlias,
              params
            }),
            store.dispatch("category/fetchCategroy",{
              types: ['brand'],
              pageAlias: routeTo.params.categoryAlias
            })
          ])
          routeTo.meta.alias = routeTo.params.categoryAlias
          routeTo.params.list = items
          routeTo.params.topList = featured
          routeTo.params.pagination = pagination
          routeTo.params.brandOptions = brandOptions.brand
          // routeTo.params.breadcrumbTitle = routeTo.params.categoryAlias === 'promotion'
          //   ? '促銷訊息'
          //   : '品牌新訊'

          next()
        } catch(error) {
          console.log('error1 :>> ', error);
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '最新消息列表',
    },
    props: (route) => ({
      list: route.params.list,
      topList: route.params.topList,
      pagination: route.params.pagination,
      brandOptions: route.params.brandOptions,
    })
  },
  // 代理品牌 品牌新訊/促銷訊息 內容頁
  {
    path: '/news/:categoryAlias/:newsAlias',
    name: 'news-item',
    component: () => import('@views/Brand/News/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const currentItem = await store.dispatch('article/fetchItem', {
            contentType: routeTo.params.categoryAlias,
            alias: routeTo.params.newsAlias,
          })
          if(currentItem.status === "ITEM_INSUFFICIENT_PERMISSION_VIEW") {
            await store.dispatch('auth/fetchUser')
            alert(`此頁面為經銷商會員限定觀看\n若你想成為經銷商會員，請與我們洽詢`);
            window.history.back();
          } else {
            routeTo.params.defaultValue = currentItem.items;
          }
          const [currentBrand] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: currentItem.items.brands[0].alias
            }),
          ])
          routeTo.meta.alias = routeTo.params.categoryAlias
          routeTo.params.currentBrand = currentBrand;
          // routeTo.params.breadcrumbTitle = currentItem.title;
          routeTo.params.breadcrumbLevel2Title = routeTo.params.categoryAlias === 'promotion'
            ? ' 促銷訊息'
            : '品牌新訊'

          next()
        } catch(error) {
            routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '最新消息',
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      // currentBrand : route.params.currentBrand || {},
    })
  },
]
